module dg.uiRouter {

    export class StateProviderBuilderService {

        private $stateProvider: ng.ui.IStateProvider;

        private static readonly defaultQueryResultViewTemplateUrl: string = '/digmo/src/actions/query-result/default-query-result-view.html';
        private static readonly defaultQueryViewTemplateUrl: string = '/digmo/src/actions/default-query-view.html';
        //private static readonly defaultModalListViewTemplateUrl: string = '/digmo/src/actions/default-modal-list-view.html';

        public static configure($stateProvider: ng.ui.IStateProvider) {
            let builder = new StateProviderBuilderService($stateProvider);
            return builder;
        }

        private constructor($stateProvider: ng.ui.IStateProvider) {
            this.$stateProvider = $stateProvider;
        }

        public dashboardState(dashboardStateName: string,
            url: string, apiUrl: string,
            resolve: dg.actions.IQueryStateResolve) {

            let defaultResolve: dg.actions.IQueryStateResolve = {
                //headerUrl: () => '/digmo/src/actions/query-result/dashboard-view-header.html',
                viewCssClass: () => 'dashboard-view',
                queryParams: this.queryParamsResolver,
                //queryResult: (actionService: dg.actions.ActionService, $transition$: any) => {
                //    let replaced = this.replaceUrnParameters($transition$.params(), apiUrl);
                //    //return actionService.getQueryResult(`/${replaced}/result`);
                //    return actionService.getQueryResult(`/${replaced}`);
                //},
                //contentTemplate: () => templateUrl + '-dashboard',
                query: (actionService: dg.actions.ActionService, $transition$: any, queryParams: any) => {

                    let replaced = this.replaceUrnParameters($transition$.params(), apiUrl);
                    return <ng.IPromise<dg.domain.queries.ListQuery<dg.domain.IDomainObject>>>actionService.getAction(`/${replaced}/`, queryParams);
                }
            };

            //var template = '<dashboard query="$resolve.query" template-url="' + templateUrl + '" title="$resolve.dashboardTitle" subtitle="$resolve.dashboardSubtitle" />';

            defaultResolve = dgUtils.ObjectHelperService.mergeDeep(defaultResolve, resolve);

            let state: angular.ui.IStateGen<dg.actions.IQueryStateResolve> = {
                url: url,
                templateUrl: StateProviderBuilderService.defaultQueryViewTemplateUrl,
                apiUrl: apiUrl,
                resolve: defaultResolve,
            }

            return this.state(`app.${dashboardStateName}`, state);
        }

        public detailsState(detailsStateName: string,
            url: string, apiUrl: string,
            resolve: dg.actions.IQueryResultDisplayerStateResolve) {

            url = `${url}/:aggregateId/details`;

            let defaultResolve: dg.actions.IQueryResultDisplayerStateResolve = {
                headerUrl: () => '/digmo/src/actions/query-result/details-view-header.html',
                viewCssClass: () => 'details-view',
                queryParams: this.queryParamsResolver,
                queryResult: (actionService: dg.actions.ActionService, $transition$: any, $location: ng.ILocationService) => {

                    //asume that all details links do not need parentId but it exists in the urn becaouse of security
                    let replaced = this.replaceUrnParameters($transition$.params(), apiUrl);

                    return actionService.getQueryResult(`/${replaced}/result`);
                }
            };

            defaultResolve = dgUtils.ObjectHelperService.mergeDeep(defaultResolve, resolve);

            let state: angular.ui.IStateGen<dg.actions.IQueryResultDisplayerStateResolve> = {
                url: url,
                templateUrl: StateProviderBuilderService.defaultQueryResultViewTemplateUrl,
                apiUrl: apiUrl,
                resolve: defaultResolve
            }

            return this.state(`app.${detailsStateName}`, state);
        }

        public listState(listStateName: string,
            url: string, apiUrl: string,
            resolve: dg.actions.IQueryStateResolve) {

            let defaultResolve: dg.actions.IQueryStateResolve = {
                viewCssClass: () => 'list-view',
                queryParams: this.queryParamsResolver,
                //transitionParams: ($transition$: any) => {
                //    return $transition$.params();
                //},
                //contentTemplate: () => '/digmo/src/actions/list-query/list-query',
                query: (actionService: dg.actions.ActionService, $transition$: any, queryParams: any) => {

                    let replaced = this.replaceUrnParameters($transition$.params(), apiUrl);
                    return <ng.IPromise<dg.domain.queries.ListQuery<dg.domain.IDomainObject>>>actionService.getAction(`/${replaced}/`, queryParams);
                }
            }

            defaultResolve = dgUtils.ObjectHelperService.mergeDeep(defaultResolve, resolve);

            let state: angular.ui.IStateGen<dg.actions.IQueryStateResolve> = {
                templateUrl: StateProviderBuilderService.defaultQueryViewTemplateUrl,
                apiUrl: apiUrl,
                resolve: defaultResolve,
            }

            if (url) {
                state.url = url;
            }

            let stateName = `app.${listStateName}`;


            return this.state(stateName, state);
        }

        public modalListState(stateName: string,
            apiUrl: string,
            resolve: dg.actions.IModalListQueryStateResolve,
            modalOptions: dg.modals.IModalOptions) {

            let defaultResolve: any = {
                //viewCssClass: () => 'list-view',
                link: this.linkResolver,
                query: (actionService: dg.actions.ActionService, $transition$: any, link: dg.restfulApi.Link) => {
                    return <ng.IPromise<dg.domain.queries.ListQuery<dg.domain.IDomainObject>>>actionService.getActionFromLink(link);
                },
            };

            if (modalOptions && modalOptions.windowClass) {
                modalOptions.windowClass = 'modal-list ' + modalOptions.windowClass;
            }

            defaultResolve = dgUtils.ObjectHelperService.mergeDeep(defaultResolve, resolve);

            let state: angular.ui.IStateGen<dg.actions.IWidgetStateResolve> = {
                templateUrl: StateProviderBuilderService.defaultQueryViewTemplateUrl,
                apiUrl: apiUrl,
                resolve: defaultResolve,
                abstract: true,
                modalOptions: modalOptions,
                params: {
                    link: null
                }
            }

            return this.state(stateName, state);
        }

        public widgetState(
            widgetStateName: string,
            apiUrl: string,
            templateType: string,
            resolve: dg.actions.IWidgetStateResolve,
            modalOptions?: dg.modals.IModalOptions) {

            let defaultResolve: dg.actions.IWidgetStateResolve = {
                //headerUrl: () => '/src/layout/blocks/view/dashboard-view-header.html',
                viewCssClass: () => 'widget-view',
                queryParams: this.queryParamsResolver,
                link: this.linkResolver
            };

            defaultResolve = dgUtils.ObjectHelperService.mergeDeep(defaultResolve, resolve);

            let template = '<widget id="{{$resolve.viewId}}" template-type="' + templateType + '" widget-title="{{$resolve.widgetTitle}}" widget-id="$resolve.queryResult.aggregate.displayValue" query-execution-strategy="$resolve.queryExecutionStrategy" link="$resolve.link" exclude-in-filter="$resolve.excludeInFilter" include-in-filter="$resolve.includeInFilter" widget-template-url="{{$resolve.widgetTemplateUrl}}"></widget>';

            if (modalOptions && modalOptions.windowClass) {
                modalOptions.windowClass = 'modal-widget ' + modalOptions.windowClass;
            }

            let state: angular.ui.IStateGen<dg.actions.IWidgetStateResolve> = {
                template: template,
                params: {
                    link: null
                },
                apiUrl: apiUrl,
                resolve: defaultResolve,
                abstract: true,
                modalOptions: modalOptions
            }

            return this.state(widgetStateName, state);
        }

        public commandState(stateName: string, options?: {apiUrl?: string, propTemplateUrl?: string, modalOptions?: modals.IModalOptions}) {

            let state: angular.ui.IStateGen<dg.actions.ICommandStateResolve> = {
                apiUrl: options && options.apiUrl,
                template: '<command-invoker id="{{$resolve.viewId}}" form-editor command="$resolve.command" prop-template-url="$resolve.propTemplateUrl"></command-invoker>',
                params: {
                    link: null
                },
                resolve: {
                    link: this.linkResolver,
                    command: (actionService: dg.actions.ActionService, link: dg.restfulApi.Link) => {
                        let params;
                        if (link.getDynamicParams) {
                            params = link.getDynamicParams();
                        }
                        return actionService.getAction(link.href, params);
                    },
                    propTemplateUrl: () => {
                        return options && options.propTemplateUrl;
                    }
                },
                modalOptions: (options && options.modalOptions) || {},
                abstract: true
            }

            //state.params['app.' + stateName + '_link'] = null;

            return this.state(stateName, state);
        }


        public exportState(stateName: string) {

            let state: angular.ui.IStateGen<dg.actions.IExportStateResolve> = {
                template: '<export-invoker form-editor query="$resolve.query" link="$resolve.link" file-id="$resolve.queryResult.aggregate.displayValue"></export-invoker>',
                params: {
                    link: null,
                    query: null,
                    fileId: null
                },
                resolve: {
                    link: this.linkResolver,
                    query: this.queryResolver,
                },
                modalOptions: {

                },
                abstract: true
            }

            return this.state(stateName, state);
        }

        public state<TStateResolve extends angular.ui.IViewStateResolve>(stateName: string,
            stateGen: angular.ui.IStateGen<TStateResolve>) {

            let structure: angular.ui.IStateGen<angular.ui.IViewStateResolve> = {
                //templateUrl: templateUrl,
                //apiUrl: apiUrl,
                reloadOnSearch: false,
                resolve: {
                    viewId: ($transition$) => {
                        return <string>$transition$.to().name.split('.').join('-');
                    }
                },
                params: {
                    queryParams: null
                }
            }

            structure = dgUtils.ObjectHelperService.mergeDeep(structure, stateGen);

            if (structure.apiUrl) {
                structure.apiUrl = `/${structure.apiUrl}`;
            }

            //if (url) {
            //    structure.url = url;
            //}

            //if (isAbstract) {
            //    structure.abstract = true;
            //}

            this.$stateProvider.state(stateName, structure);

            return this;
        }

        private linkResolver = ($transition$: any) => {

            let link: dg.restfulApi.Link = $transition$.params()[$transition$.to().name + '_link'];

            return link;
        }

        private queryResolver($transition$: any) {
            let query: dg.domain.actions.IDomainAction = $transition$.params().query;

            return query;
        }

        private queryParamsResolver($transition$: any, $location: ng.ILocationService) {
            let params: any;
            //if ($transition$.from().url == '^') {
            if ('/' + $transition$.to().url == $location.path()) {
                params = $location.search();
            } else {
                params = $transition$.params().queryParams || {};
            }

            return params;
        }

        private replaceUrnParameters(params: any, apiUrl: string) {
            apiUrl = this.replaceUrnParameter(params, 'aggregateId', apiUrl);
            apiUrl = this.replaceUrnParameter(params, 'parentId', apiUrl);

            return apiUrl;
        }

        private replaceUrnParameter(params: any, paramName: string, apiUrl: string) {
            if (params[paramName]) {
                apiUrl = apiUrl.replace(`{${paramName}}`, params[paramName]);
            }
            else {
                apiUrl = apiUrl.replace(`{${paramName}}/`, '');
            }
            return apiUrl;
        }
    }

    angular.module('dg.uiRouter')
        .service('stateProviderBuilderService', StateProviderBuilderService);
}